function setScrollPosition(top: number, left: number) {
    window.scrollTo({ top:top, left:left, behavior: "auto"})
}

export {setScrollPosition}